import { render, staticRenderFns } from "./prizesDetails.vue?vue&type=template&id=5eada9c0&scoped=true&"
import script from "./prizesDetails.vue?vue&type=script&lang=js&"
export * from "./prizesDetails.vue?vue&type=script&lang=js&"
import style0 from "./prizesDetails.vue?vue&type=style&index=0&id=5eada9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eada9c0",
  null
  
)

export default component.exports